export class UILifeCycle{
    initLifeCycle(){
        this.on('added', () => {
            PIXI.ticker.shared.add((delta) => this.onTicker(delta));
            this.onAdded();
        });
        this.on('removed', () => {
            PIXI.ticker.shared.remove((delta) => this.onTicker(delta))
            this.onRemoved();
        });

        this._keyHandlers = {};
        this._dirtyKeyDict = {};
        this._dirtyKeys = [];
        this.rgEvent("render", false, this.redraw);
    }

    rgEvent(key, emitEvent, func, context){
        this._keyHandlers[key] = {func:func, context: context || this, emitEvent:emitEvent};
    }

    rmEvent(key){
        this._keyHandlers[key] = null;
    }

    onTicker(delta) {
        this.onFrame();
        let keys = this._dirtyKeys;
        if(keys.length){
            keys = keys.concat();
            this._dirtyKeyDict = {};
            this._dirtyKeys.length = 0;
            for(let i = 0, len = keys.length; i < len; i++){
                const key = keys[i];
                const handler = this._keyHandlers[key];
                if(handler.func){
                    handler.func.call(handler.context, key);
                }
                if(handler.emitEvent){
                    this.emit(key);
                }
            }
        }
    }

    dirty() {
        this.event("render");
    }

    event(key){
        if(!this._dirtyKeyDict[key] && this._keyHandlers[key]){
            this._dirtyKeyDict[key] = true;
            this._dirtyKeys.push(key);
        }
    }

    onFrame() {
    }

    onAdded(){
    }
    
    onRemoved(){}
    

    redraw() {
    }

    resize(w, h){

    }

    dispose() {
    }
}

export default function mixinUILifeCycle(classz){
    const proto = UILifeCycle.prototype;
    const cProto = classz;

    const properties = Object.getOwnPropertyDescriptors(proto);
    for(let k in properties){
        if(!cProto.hasOwnProperty(k)){
            Object.defineProperty(cProto, k, properties[k]);
        }
    }
}


// WEBPACK FOOTER //
// ./src/common/scripts/pixi/component/UILifeCycle.js